"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const signature_pad_1 = __importDefault(require("signature_pad"));
const Signature_1 = require("./Signature");
/**
 * @param {string} value
 * @param {object} [options]
 * @param {number} [options.width]
 * @param {number} [options.height]
 * @returns {string}
 */
const valueToDataUrl = (value, options = {}) => {
    const { width = Signature_1.DEFAULT_CANVAS_WIDTH, height = Signature_1.DEFAULT_CANVAS_HEIGHT } = options;
    const canvas = document.createElement('canvas');
    canvas.style.position = 'absolute';
    canvas.style.left = '-9999px';
    canvas.width = width;
    canvas.height = height;
    document.body.appendChild(canvas);
    const signaturePad = new signature_pad_1.default(canvas);
    signaturePad.fromData(JSON.parse(value));
    const dataURL = signaturePad.toDataURL();
    document.body.removeChild(canvas);
    return dataURL;
};
exports.default = valueToDataUrl;
//# sourceMappingURL=valueToDataUrl.js.map